import { FC } from 'react';

import { CallDetailHeader } from '../reservation/header/call_detail_header';
import { CallDetailNotes } from '../reservation/call_detail_notes';

export const NoReservationCallDetailsWithNoteEditor: FC = () => {
    return (
        <section>
            <CallDetailHeader />
            <CallDetailNotes />
        </section>
    );
};
